export default "__VITE_ASSET__BXYAFHNe__"